<template>
  <!-- Cross Country + Road Rally roadbook pages side by side (stacked on phones),
       same images and layout as the home page, each linking to its guide.
       Used at the top of the rally-roadbook pages, so the images load eagerly.
       Alt texts are props so the translated pages can pass their own. -->
  <div class="flex flex-col md:flex-row gap-8 p-8 w-full justify-between">
    <router-link to="/how-to-create-a-cross-country">
      <picture class="contents">
        <source
          srcset="/images/CC-Roadbook-Image-qbqkj0exbp9dd466e7ex7ryf7wdwx9qdmhdcijtm1k.webp"
          type="image/webp"
        />
        <img
          decoding="async"
          fetchpriority="high"
          src="/images/CC-Roadbook-Image-qbqkj0exbp9dd466e7ex7ryf7wdwx9qdmhdcijtm1k.png"
          :alt="ccAlt"
          width="450"
          height="700"
          class="m-auto"
        />
      </picture>
    </router-link>
    <router-link to="/how-to-create-a-road-rally">
      <picture class="contents">
        <source
          srcset="/images/Road-Rally-Roadbook-qbqkj0exbp9dd466e7ex7ryf7wdwx9qdmhdcijtm1k.webp"
          type="image/webp"
        />
        <img
          decoding="async"
          src="/images/Road-Rally-Roadbook-qbqkj0exbp9dd466e7ex7ryf7wdwx9qdmhdcijtm1k.png"
          :alt="rrAlt"
          width="450"
          height="700"
          class="m-auto"
        />
      </picture>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'RoadbookSamplePair',
  props: {
    ccAlt: {
      type: String,
      default:
        'Cross country rally roadbook page made in Rally Navigator, with distances, tulip diagrams and FIA navigation icons',
    },
    rrAlt: {
      type: String,
      default:
        'Road and stage rally roadbook page made in Rally Navigator, with time controls, tulip diagrams and distances',
    },
  },
};
</script>
